export default __webpack_public_path__ + "static/media/fa.bundle.82c26ee6.svg";